import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0a2540', // Deep Navy: Trust & Engineering
      light: '#3a4b60',
      dark: '#000020',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2e7d32', // Forest Green: Agriculture & Environment
      light: '#60ad5e',
      dark: '#005005',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a202c', // Soft black
      secondary: '#4a5568', // Slate grey
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.2 },
    h2: { fontWeight: 700, letterSpacing: '-0.01em', color: '#0a2540' },
    h3: { fontWeight: 600, color: '#0a2540' },
    h5: { fontWeight: 500 },
    button: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, boxShadow: 'none', padding: '10px 24px' },
        containedPrimary: {
          '&:hover': { boxShadow: '0 4px 14px 0 rgba(0,0,0,0.2)' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' },
      },
    },
  },
});

export default theme;